// extracted by mini-css-extract-plugin
export default {"inner":"udBsCqHv","formContent":"PtnxEO3D","welcome":"zCDwNR9J","content":"JZxgfvFi","group":"PJpOmMv1","buttonsWrapper":"ATmzNoIc","error":"YOfDLwOX"};